import { Form } from 'antd';
import { useLines } from '@/hooks/v1';
import { useResolution886Report } from '@/context/Resolution886Report';

const { useFormInstance, useWatch } = Form;

interface LineProps {
	fieldName?: string | string[];
}

export function useLine({ fieldName }: LineProps) {
	const form = useFormInstance();
	const { newReview, firstReview } = useResolution886Report();

	const field = Array.isArray(fieldName) ? fieldName[0] : null;

	const organization_id = useWatch(field ? [field, 'organization_id'] : 'organization_id');
	const company_id = useWatch(field ? [field, 'company_id'] : 'company_id');
	const sector_id = useWatch(field ? [field, 'sector_id'] : 'sector_id', form);
	const line_id = useWatch(field ? [field, 'line_id'] : 'line_id');

	function handleSelectLine(id: string): void {
		form.setFieldValue(field ? [field, 'line_id'] : ['line_id'], id);
		form.setFieldValue(field ? [field, 'workstation_id'] : ['workstation_id'], undefined);
	}

	function handleClearLines(): void {
		form.setFieldValue(field ? [field, 'line_id'] : ['line_id'], undefined);
		form.setFieldValue(field ? [field, 'workstation_id'] : ['workstation_id'], undefined);
	}

	const {
		isLoading,
		isFetching,
		data: lines = [],
		isError
	} = useLines({
		organization_id: organization_id!,
		company_id: company_id!,
		sector_id: sector_id!
	});

	const items = lines.map((line) => ({
		label: line.name,
		value: line.id
	}));

	const isDisabled = !company_id || !sector_id || newReview || !firstReview;

	return {
		items,
		isLoading,
		isFetching,
		isError,
		isDisabled,
		lineId: line_id,
		handleSelectLine,
		handleClearLines
	};
}
